import {Component, Input} from "@angular/core";
import {Product} from "../../../../objects/products/product";
import {ProductModalComponent} from "../modal/productModal.component";
/**
 * Created by alex.y on 9/11/2017.
 */


@Component({
    selector: 'product-item',
    templateUrl: 'productItem.component.html',
    moduleId: module.id.toString()
})
export class ProductItemComponent {

    @Input()
    public product: Product;

    public string = String;

    @Input()
    public productModal: ProductModalComponent;

}


// WEBPACK FOOTER //
// ./app/components/Managment/productManagement/productItem/productItem.component.ts